import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-gamepage',
  templateUrl: './gamepage.component.html',
  styleUrls: ['./gamepage.component.css']
})
export class GamepageComponent implements OnInit {
  gameid="index.html"
  userid="8890";
  game_object:any;
  user_ob:any;
  url:string
  constructor(private games:GamesService ,private route:ActivatedRoute , private router:Router) {
    this.gameid=this.route.snapshot.paramMap.get('game_id');
    this.user_ob= JSON.parse(localStorage.getItem('user'));

    this.games.getGameData(this.gameid).subscribe(
      next=>{
        this.game_object=next;
        //+`?param1=${this.user_ob.user_id}&param2=${this.gameid}`
        console.log(next)
        this.url=this.game_object.game_folder+`/index.html?`+`params1=${this.userid}&param2=${this.gameid}`;
       // this.url=`${this.game_object.game_folder}/index.html`+`?params1=${this.userid}&param2=${this.gameid}`;

     // console.log(this.game_object.game_liks.length)
    },
      error=>{console.log(error)}
    )
    
   }

  ngOnInit() {
  }
  disactive(){
    this.games.disactiveGame(this.gameid).subscribe(next=>{console.log(next)})

  }
  delete(){
    this.games.deleteGame(this.gameid).subscribe(next=>{console.log(next)})

  }
  edit(){
    this.router.navigate(['/editgame',this.gameid]); 
  }

  //disactive game 


   
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/gamepage/gamepage.component.ts